import { create } from 'zustand'
import { type ConstantOption, type Constants, getConstants } from '@/api/constants'

interface ConstantsState {
  constants: Constants | null
  loading: boolean
  error: string | null
  fetchConstants: () => Promise<void>
  getOptions: (key: keyof Constants) => ConstantOption[]
  getLabel: (key: keyof Constants, value: string) => string
}

export const useConstantsStore = create<ConstantsState>((set, get) => ({
  constants: null,
  loading: false,
  error: null,

  fetchConstants: async () => {
    if (get().constants) return

    set({ loading: true, error: null })
    try {
      const constants = await getConstants()
      set({ constants, loading: false })
    } catch (error) {
      set({ error: 'Failed to load constants', loading: false })
      console.error('Failed to load constants:', error)
    }
  },

  getOptions: (key) => {
    const constants = get().constants
    if (!constants) return []
    return constants[key] || []
  },

  getLabel: (key, value) => {
    const options = get().getOptions(key)
    const option = options.find((opt) => opt.value === value)
    return option?.label || value
  },
}))
